// The masterclass page's own words, the ones that aren't settings (Masterclass.dc.html, word for
// word). The offer's every line, both of its links, its minute and the owner's card are the owner's
// settings, read through hub.my_offer_state (docs/data-model.md 10.2); the questions line's address
// is the product's own (catalogue.questions_email, decision 38). Pure: no imports.

export const COPY = {
  eyebrow: 'Video, recorded',
  // "1 hour 48 minutes. Carry on where you left off, on any device you log in on."
  lede: length => (length ? `${length}. ` : '') + 'Carry on where you left off, on any device you log in on.',
  // before any watching there's nowhere to carry on from (member review, 11 Oct), so the line says what
  // will happen, in Next up's words for the video not yet started
  ledeFirst: length => (length ? `${length}. ` : '') + 'It picks up where you leave off, on any device.',
  coverTitle: "You're in. Press play.",
  coverSub: length => (length ? `${length}, so give it the evening it deserves.` : 'Give it the evening it deserves.'),
  coverPlay: 'Play the video',
  coverCarryOn: at => `Play, carrying on from ${at}`,
  watched: pct => `${pct}% watched`,
  carryOn: at => `Carry on from ${at}`,
  start: 'Start watching',
  restart: 'Start from the beginning',
  progressHead: 'Your progress',
  progressWatched: 'watched',
  questionsHead: 'Questions',
  questions: email => `Email ${email} and Adam replies himself.`,
  // PhoneWeek.dc.html's line under every player on a phone
  sideways: 'Turn your phone sideways for full screen.',
  // reference/masterclass-watch-page's footer, under the video, without its last 2 sentences
  // ("This page is for the person who bought the masterclass. Please don't share it."): Adam, 3 Oct.
  // "are not" is "aren't" here, by the writing rules.
  disclaimer: 'Educational content only. Nothing here is financial, legal, tax or investment advice, and nothing here is a personal recommendation. Worked examples are illustrations, not a forecast, and my own results aren\'t a promise of yours. Speak to a suitably qualified professional before acting on anything you\'ve watched.',
  // the shared recording page's lines (src/product/RecordingPage.jsx, Player.jsx)
  notReady: "This recording isn't ready to play yet.",
  // the hub's 1 line for something that didn't load (stage 3's, approved; the help address, decision 38)
  loadFailed: "That didn't load. Check your connection and try again. If it keeps happening, email adam@adamslee.co.uk.",
}
